import React, { useState } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import {  ToastContainer } from 'react-toastify';

import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';

import styles from './mainLayout.module.scss';

function MainLayout() {

  const navigate = useNavigate();
  const location = useLocation();

//====State start here====  
  const [key, setKey] = useState(Date.now());

//====State end here====

//====Event handler start here====
  const handleRefresh = () => {
    setKey(Date.now());  // Change the key to trigger re-mount
    navigate(window.location.pathname); // Re-navigate to the current path
  };


//====Event handler end here====  

  return (
    <div className={styles.MainLayout}>
      <Navbar onIconClick={handleRefresh} /> {/* Pass handleRefresh to Navbar */}
         
         <div className={styles.wrapper} key={`${location.pathname}-${key}`}>
         <Outlet /> {/* keyed wrapper re-mounts on navigation → page-enter animation */}
         </div>

        <Footer/>

        <ToastContainer 
         rtl />

    </div>
  )
}

export default MainLayout